__turbopack_context__.v({
  "backdrop": "styles-module-scss-module__OFGQIq__backdrop",
  "backdropFadeIn": "styles-module-scss-module__OFGQIq__backdropFadeIn",
  "button": "styles-module-scss-module__OFGQIq__button",
  "buttonPrimary": "styles-module-scss-module__OFGQIq__buttonPrimary",
  "buttonSecondary": "styles-module-scss-module__OFGQIq__buttonSecondary",
  "buttons": "styles-module-scss-module__OFGQIq__buttons",
  "content": "styles-module-scss-module__OFGQIq__content",
  "enter": "styles-module-scss-module__OFGQIq__enter",
  "exit": "styles-module-scss-module__OFGQIq__exit",
  "fade-in": "styles-module-scss-module__OFGQIq__fade-in",
  "fade-out": "styles-module-scss-module__OFGQIq__fade-out",
  "fade-out-80": "styles-module-scss-module__OFGQIq__fade-out-80",
  "icon": "styles-module-scss-module__OFGQIq__icon",
  "labels": "styles-module-scss-module__OFGQIq__labels",
  "modal": "styles-module-scss-module__OFGQIq__modal",
  "modalFadeIn": "styles-module-scss-module__OFGQIq__modalFadeIn",
  "slide-in-from-bottom": "styles-module-scss-module__OFGQIq__slide-in-from-bottom",
  "slide-in-from-left": "styles-module-scss-module__OFGQIq__slide-in-from-left",
  "slide-in-from-right": "styles-module-scss-module__OFGQIq__slide-in-from-right",
  "slide-in-from-top": "styles-module-scss-module__OFGQIq__slide-in-from-top",
  "slide-out-to-bottom": "styles-module-scss-module__OFGQIq__slide-out-to-bottom",
  "slide-out-to-left": "styles-module-scss-module__OFGQIq__slide-out-to-left",
  "slide-out-to-right": "styles-module-scss-module__OFGQIq__slide-out-to-right",
  "slide-out-to-top": "styles-module-scss-module__OFGQIq__slide-out-to-top",
  "text": "styles-module-scss-module__OFGQIq__text",
  "title": "styles-module-scss-module__OFGQIq__title",
  "width-320": "styles-module-scss-module__OFGQIq__width-320",
  "width-400": "styles-module-scss-module__OFGQIq__width-400",
  "zoom-in": "styles-module-scss-module__OFGQIq__zoom-in",
  "zoom-out": "styles-module-scss-module__OFGQIq__zoom-out",
});
